import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { prepareData } from 'helpers/prepare-req-data'
import { prepParams } from 'helpers/prep-req-url'
import { getRespData  } from 'helpers/get-resp-data'
import client from 'api'
import _ from 'lodash'

import { v4 as uuid4 } from 'uuid'


const initialState = {
    startProcess3025Status: 'idle',
    startProcess3025Error: undefined as any,
    loadUserParamsProcess3025Status: 'idle',
    loadUserParamsProcess3025Error: undefined as any,

    process3025List: [] as any[],
    defaultValues: undefined as any,
    job: undefined as any,
    filterValues: {} as any,
    filterLookupValues: {} as any,

    directLoad: false,
    load: false,
    activeDivRef: null as any,

    filterValuesId: null,
    valuesFromDB: false,
    filterVisibleId: null,
    filterVisible: true,
}


export const startProcess3025 = createAsyncThunk('process3025Slice/startProcess3025', async ({ process3025 }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.post(
        `/api/ixweb/StartProcess3025/`,
        prepareData(process3025),
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { startProcess3025Status } = getState().process3025Slice
        return startProcess3025Status !== 'pending'
    }
})

export const loadUserParamsProcess3025 = createAsyncThunk('process3025Slice/loadUserParamsProcess3025', async (_: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/LoadUserParamsProcess3025/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadUserParamsProcess3025Status } = getState().process3025Slice
        return loadUserParamsProcess3025Status !== 'pending'
    }
})

const Process3025Slice = createSlice({
    name: 'process3025Slice',
    initialState,
    reducers: {
        resetstartProcess3025: (state) => {
            state.job = undefined
            state.startProcess3025Error = undefined
        },
        resetstartProcess3025Error: (state) => {
            state.startProcess3025Error = undefined
        },
        resetloadUserParamsProcess3025: (state) => {
            state.defaultValues = undefined
            state.loadUserParamsProcess3025Error = undefined
        },
        resetloadUserParamsProcess3025Error: (state) => {
            state.loadUserParamsProcess3025Error = undefined
        },
        removeFromProcess3025ListById: (state, action) => {
            state.process3025List = state.process3025List.filter((x: any) => x.HDR_ID !== action.payload)
        },
        removeFromProcess3025ListByIds: (state, action) => {
            state.process3025List = state.process3025List.filter((x: any) => action.payload.indexOf(x.HDR_ID) === -1)
        },
        setFilterValues: (state, action) => {
            if (action.payload === undefined || action.payload === null) {
                state.filterValues = {}
            } else {
                state.filterValues = { ...state.filterValues, ...action.payload }
            }
        },
        setFilterLookupValue: (state, action) => {
            const { name, value, formValue } = action.payload
            if (name) {
                state.filterLookupValues[name] = value
                state.filterValues[name] = formValue
            }
        },
        setDirectLoad: (state, action) => { state.directLoad = action.payload },
        setLoad: (state, action) => { state.load = action.payload },
        setActiveDivRef: (state, action) => { state.activeDivRef = action.payload},
        setFilterValuesId: (state, action) => {
            state.filterValuesId = action.payload
        },
        setValuesFromDB: (state, action) => {
            state.valuesFromDB = action.payload
        },
        setFilterVisibleId: (state, action) => {
            state.filterVisibleId = action.payload
        },
        setFilterVisible: (state, action) => {
            state.filterVisible = action.payload
        },
        preloadData: (state, action) => {
            state.process3025List = action.payload.map((x: any) => ({ ...x, HDR_ID: uuid4()}))
            state.startProcess3025Status = 'preloaded'
        },
        clearPreloadedData: (state) => {
            state.process3025List = []
            state.startProcess3025Status = 'idle'
        },
    },
    extraReducers: builder => {
        builder.addCase(startProcess3025.pending, (state) => {
            state.startProcess3025Status = 'pending'
            state.startProcess3025Error = undefined
        })
        builder.addCase(startProcess3025.fulfilled, (state, action) => {
            state.startProcess3025Status = 'idle'

            {
                state.job = action.payload

            }
        })
        builder.addCase(startProcess3025.rejected, (state, action) => {
            state.startProcess3025Status = 'error'
            if (action.error.message !== 'Rejected') {
                state.startProcess3025Error = action.error.message
            } else {
                state.startProcess3025Error = action.payload
            }
        })

        builder.addCase(loadUserParamsProcess3025.pending, (state) => {
            state.loadUserParamsProcess3025Status = 'pending'
            state.loadUserParamsProcess3025Error = undefined
        })
        builder.addCase(loadUserParamsProcess3025.fulfilled, (state, action) => {
            state.loadUserParamsProcess3025Status = 'idle'

            {
                state.defaultValues = action.payload

            }
        })
        builder.addCase(loadUserParamsProcess3025.rejected, (state, action) => {
            state.loadUserParamsProcess3025Status = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadUserParamsProcess3025Error = action.error.message
            } else {
                state.loadUserParamsProcess3025Error = action.payload
            }
        })

    }
})

export const {
    resetstartProcess3025,
    resetstartProcess3025Error,
    resetloadUserParamsProcess3025,
    resetloadUserParamsProcess3025Error,
    removeFromProcess3025ListById,
    removeFromProcess3025ListByIds,
    setFilterValues,
    setFilterLookupValue,
    setDirectLoad,
    setLoad,
    setActiveDivRef,
    setFilterValuesId,
    setValuesFromDB,
    setFilterVisible,
    setFilterVisibleId,
    preloadData,
    clearPreloadedData,
} = Process3025Slice.actions
export default Process3025Slice.reducer
